import type { ReactElement } from 'react';
import { useFlags } from '@flagsmith/flagsmith/react';
import Button from 'react-bootstrap/Button';
import { Component as CircleErrorIcon } from 'icons/icon-circle--error.svg';

import { cancelOptions } from 'platform/modals/subscription.types';
import { post } from 'utils/network';
import { ApiRoute, Route } from '../../utils/config';
import styles from './CancelModalContainer.module.scss';

type Props = {
  reason: string;
  onContinueToCancel: () => void;
};

function CancelRebuttalModal({
  onContinueToCancel,
  reason,
}: Props): ReactElement {
  const { cancel_rebuttal_promo: cancelRebuttalPromo } = useFlags(['cancel_rebuttal_promo']);
  const enableCancelRebuttalPromo = cancelRebuttalPromo?.enabled && cancelRebuttalPromo?.value === 'show';
  const rebuttal = cancelOptions.find((o) => o.id === reason)?.rebuttal;

  const handleKeepSubscription = async () => {
    if (enableCancelRebuttalPromo) {
      await post(ApiRoute.APPLY_REBUTTAL_PROMO, {});
    }
    window.location.href = Route.HUB;
  };

  return (
    <div>
      <div style={{
        fontSize: '14px',
        marginBottom: '1rem',
      }}
      >
        {rebuttal?.preCard}
      </div>
      {/* Rebuttals eventually will be adjustable in admin */}
      {rebuttal?.items && (
        <div className={styles.rebuttal_box}>
          {/* TODO: header adjustable in admin  */}
          <div className={styles.rebuttal_header}>If you cancel your account:</div>
          {/* TODO: "card" (3 reasons for what's lost on cancel) pulled from admin  */}
          {rebuttal.items.map((sentence) => (
            <div key={sentence} className={styles.rebuttal_items}>
              <CircleErrorIcon
                height="16"
                width="16"
                className={styles.error_icon}
              />
              <span>{sentence}</span>
            </div>
          ))}
        </div>
      )}
      <div style={{
        fontSize: '14px',
        marginBottom: '1rem',
      }}
      >
        {rebuttal?.postCard}
      </div>
      {/* TODO: currently apply promo from what is in config. */}
      {/*   This eventually will be defined in admin  */}
      <Button
        className="c-button c-button--primary btn btn-dark d-flex align-items-center gap-2"
        onClick={handleKeepSubscription}
        style={{
          borderRadius: '6px',
          padding: '10px 24px',
          margin: '18px 0',
        }}
      >
        {rebuttal?.buttonText}
      </Button>
      <a
        href="#continue"
        role="button"
        onClick={(e) => {
          e.preventDefault();
          onContinueToCancel();
        }}
        className="text-dark"
        style={{
          fontSize: '14px',
          textDecoration: 'underline',
          cursor: 'pointer',
        }}
      >
        Continue To Cancel
      </a>
    </div>
  );
}

export default CancelRebuttalModal;
